import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  card: {
    width: '100%',
    maxWidth: 416,
    padding: 24,
  },
  tableHeader: {
    textAlign: 'center',
    borderBottom: `1px solid ${theme.color.greys[15]}`,
    paddingBottom: 16,
    marginBottom: 8,
  },
  productInfoSections: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& $productItemCell': {
      '&:nth-child(even)': {
        background: theme.color.greys[10],
      },
    },
  },
  productItemCell: {
    verticalAlign: 'top',
    padding: '16px 8px',
    '&:nth-child(2)': {
      '& button': {
        display: 'inline-flex',
        top: -3,
      },
    },
    '& ul': {
      listStyleType: 'square',
      paddingLeft: 24,
      margin: 0,
      '& li': {
        marginBottom: 8,
        '&:last-child': {
          marginBottom: 0,
        },
      }
    },
  },
  productItemLabel: {
    display: 'block',
    marginBottom: 4,
  },
  buttonWrapper: {
    marginTop: 16,
    paddingBottom: 16,
    marginBottom: 16,
    borderBottom: `1px solid ${theme.color.greys[15]}`,

  },
  additionalOptionsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  additionalOptionsCell: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 0',
    gap: 8,
  },
  link: {
    alignSelf: 'flex-start',
  },
}), { name: 'RetirementProductCard' });
